module.exports = __webpack_public_path__ + "static/media/cross_red.a925e3b7.svg";